const PERIOD_MONTHS = 12;
const PERIOD_SEPARATOR = '_';
export function parsePeriodStart(period: string): {
  year: number;
  month: number;
} {
  const [start] = period.split(PERIOD_SEPARATOR);
  return {
    year: Number.parseInt(start.slice(0, 4), 10),
    month: Number.parseInt(start.slice(4, 6), 10)
  };
}
function padMonth(month: number): string {
  return String(month).padStart(2, '0');
}
export function formatPeriod(startYear: number, startMonth: number): string {
  const endDate = new Date(startYear, startMonth - 1 + PERIOD_MONTHS - 1, 1);
  const endYear = endDate.getFullYear();
  const endMonth = endDate.getMonth() + 1;
  return `${startYear}${padMonth(startMonth)}${PERIOD_SEPARATOR}${endYear}${padMonth(endMonth)}`;
}
export function getDefaultPeriod(): string {
  const now = new Date();
  const startDate = new Date(now.getFullYear(), now.getMonth() - 11, 1);
  return formatPeriod(startDate.getFullYear(), startDate.getMonth() + 1);
}
export function getMonthsInPeriod(period: string): Array<{
  year: number;
  month: number;
}> {
  const start = parsePeriodStart(period);
  const months: Array<{
    year: number;
    month: number;
  }> = [];
  for (let i = 0; i < PERIOD_MONTHS; i++) {
    const date = new Date(start.year, start.month - 1 + i, 1);
    months.push({
      year: date.getFullYear(),
      month: date.getMonth() + 1
    });
  }
  return months;
}
export function periodToTargetIso(period: string): string {
  const parsed = parsePeriodStart(period);
  return new Date(Date.UTC(parsed.year, parsed.month - 1, 1)).toISOString();
}